import { gql } from 'graphql-request';
import type { GetCartResponseResult, UnavailableProduct, ViaxOrder } from '@types';

export interface GetCartResponse {
  wGetCart: {
    cart: ViaxOrder;
    removedProducts: UnavailableProduct[];
    marketRestrictedProducts: UnavailableProduct[];
    result: GetCartResponseResult
  }
}

export const GET_CART_QUERY = gql`
  mutation getCart($uid: UUID) {
    wGetCart(uid: $uid)
  }
`;
